const dictionary={
    "_completeFields":"Complete all fields and try again",
    "_toastTimeOut":5000,
    "_places_key":"AIzaSyA6QSc8USmBvolg2HQBdQKoSm1hhHDU_yQ"
    
}

export default dictionary;